import React, { ReactNode } from 'react';
import { CommonProps } from '../../Element/Element';
import Div from '../../Element/Div/Div';
import styles from './SideNavigationSubItem.module.scss';
import BodyText from '../../Typography/BodyText/BodyText';

export type SideNavigationSubItemType = {
  /** Label of the navigation item */
  label: string | ReactNode;
  /** Is the item selected? */
  active: boolean;
  /** Function that is called then user clicked */
  onClick?: () => void;
} & CommonProps<'div'>;

const SideNavigationSubItem: React.FunctionComponent<SideNavigationSubItemType> = ({
  label,
  active,
  onClick,
  ...props
}) => {
  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && onClick) {
      onClick();
      event.preventDefault();
    }
  };

  return (
    <Div
      className={[
        'side-navigation-test',
        styles.sideNavigationSubItem,
        { [styles.sideNavigationSubItem__active]: active },
      ]}
      hoverColor="purple500"
      padding={{ size: 'xs', left: 'sm' }}
      margin={{ bottom: 'sm' }}
      clickableAppearance
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...props}
    >
      <BodyText tagName="span">{label}</BodyText>
    </Div>
  );
};

export default SideNavigationSubItem;
